(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["choose_style"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('db24-accessory')) {
    customElements.define('db24-accessory', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-enhanced')) return;
        this.quantity = this.querySelector('[name="quantity"]');
        this.variant = this.querySelector('[data-accessory-variant]');
        this.minus = this.querySelector('[data-accessory-minus]');
        this.plus = this.querySelector('[data-accessory-plus]');
        this.add = this.querySelector('[type="submit"]');
        if (!this.quantity || !this.add) return;
        this.setAttribute('data-enhanced', '');
        this.addEventListener('click', (event) => {
          const control = event.target.closest('[data-accessory-minus],[data-accessory-plus]');
          if (!control || control.disabled) return;
          if (control === this.minus) this.quantity.stepDown();
          else this.quantity.stepUp();
          this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
        this.quantity.addEventListener('input', () => this.updateButtons());
        this.quantity.addEventListener('change', () => this.updateButtons());
        if (this.variant) {
          this.variant.addEventListener('change', () => this.updateVariant());
          this.updateVariant();
        } else this.updateButtons();
      }
      updateVariant() {
        const option = this.variant.selectedOptions[0];
        const unavailable = !option || !option.value || option.disabled;
        this.add.disabled = unavailable;
        this.quantity.disabled = unavailable;
        if (!unavailable) {
          this.quantity.min = option.dataset.min;
          this.quantity.step = option.dataset.step;
          if (option.dataset.max) this.quantity.max = option.dataset.max;
          else this.quantity.removeAttribute('max');
          this.quantity.value = option.dataset.min;
          this.querySelector('[data-accessory-price]').textContent = option.dataset.price;
        }
        this.updateButtons();
      }
      updateButtons() {
        const min = Number(this.quantity.min || 1);
        const max = this.quantity.max === '' ? Infinity : Number(this.quantity.max);
        const value = this.quantity.valueAsNumber;
        this.minus.disabled = this.quantity.disabled || value <= min;
        this.plus.disabled = this.quantity.disabled || value >= max;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["db24-buying-help"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '.bee-product-form__variants [data-swatch-item]';
    const sync = (item) => {
      if (!(item instanceof HTMLElement)) return;
      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-pressed', String(item.classList.contains('is--selected')));
    };
    const init = (root) => {
      root.querySelectorAll(selector).forEach(sync);
    };
    init(document);
    document.addEventListener('keydown', (event) => {
      const item = event.target.closest(selector);
      if (!item || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      if (item.getAttribute('aria-disabled') !== 'true') item.click();
    });
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        if (record.type === 'attributes' && record.target.matches(selector)) sync(record.target);
        for (const node of record.addedNodes) {
          if (node instanceof HTMLElement) { if (node.matches(selector)) sync(node); init(node); }
        }
      }
    });
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  })();
  } catch(e) { console.error(e); }
})();

})();
